import gqlRequest from 'graphql/generic';

type CreateLedgerAssociationReturn = {
  createOrderLedgerAssociation: {
    _id: string
  }
}

const queryAddPartyAssociation = `
  mutation CreateOrderLedgerAssociation($id: ID!, $accountingId: ID!, $data: OrderLedgerAssociationContent!, $kind: String!, $partyId: ID!) {
    createOrderLedgerAssociation(_id: $id, accounting_id: $accountingId, data: $data, kind: $kind, party_id: $partyId) {
      _id
    }
  }
`;

type createLedgerAssociationParams = {
  id: string,
  accountingId:string,
  data: {
    amount?: number|null,
    at_closing_amount?:number| null,
    at_closing_percent?:number| null,
    before_closing_amount?:number | null,
    before_closing_percent?:number| null,
    payment_id?:string| null,
    percent?:number | null
  },
  kind:string,
  partyId: string
}

export const addpartyLedgerAssociation = (params: createLedgerAssociationParams) => gqlRequest<CreateLedgerAssociationReturn, createLedgerAssociationParams>(queryAddPartyAssociation, params);

type updateledgerAssociationParams = {
  id: string,
  accountingId:string,
  data: {
    amount?:number | null,
    at_closing_amount?: number | null,
    at_closing_percent?:number| null,
    before_closing_amount?:number| null,
    before_closing_percent ? : number| null,
    payment_id?:string| null,
    percent?:number | null
  },
  kind: string,
  partyId: string,
}

const queryUpdateLedgerAssociation = `
mutation UpdateOrderLedgerAssociation($id: ID!, $accountingId: ID!, $data: OrderLedgerAssociationUpdateContent!, $kind: String!, $partyId: ID!) {
  updateOrderLedgerAssociation(_id: $id, accounting_id: $accountingId, data: $data, kind: $kind, party_id: $partyId) {
    _id
  }
}
`;

export const updateLedgerAssociation = (params:updateledgerAssociationParams) => gqlRequest<null, updateledgerAssociationParams>(queryUpdateLedgerAssociation, params);

export default { };
